import { FieldBase } from '@/components/form';
import { InfoPopover } from '@/components/ui/info';
import { ArbeitstageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/ArbeitstageSelect';
import { StundenbewertungBlock } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbewertungBlock';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
  Separator,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenAllgemein() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col md:gap-10 gap-6">
      <div className="flex flex-col gap-4">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7 flex items-center gap-1">
          {ctx.getCurrentSubStep()?.title}
          <InfoPopover
            text={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.info',
            )}
          />
        </h2>
        <div className="grid md:grid-cols-2">
          <form.AppField name="abwesenheiten.allgemein.anzahlUrlaubstage">
            {(field) => (
              <FieldBase
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.label',
                )}
                isRequired>
                <InputGroup>
                  <InputGroupInput
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.target.value)}
                    onBlur={field.handleBlur}
                  />
                  <InputGroupAddon align="inline-end">
                    <InputGroupText className="text-neutrals-700">
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.suffix',
                      )}
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FieldBase>
            )}
          </form.AppField>
        </div>
      </div>
      <Separator />
      <div className="flex flex-col gap-4">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7">
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.title',
          )}
        </h2>
        <form.Subscribe
          selector={(state) => state.values.abwesenheiten.allgemein.dynamisch}>
          {(dynamisch) => (
            <ArbeitstageSelect
              disableOptionFlexibel={
                dynamisch === 'wochenschnitt' ||
                dynamisch === 'drei_monatsschnitt'
              }
            />
          )}
        </form.Subscribe>
      </div>
      <Separator />
      <StundenbewertungBlock />
    </div>
  );
}
